import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import AdminGateway from '~apis/admin';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetIsMarketOpen(api: AdminGateway): SagaWatcherReturnType {
    yield takeEvery('auth/authGetIsMarketOpenAttempt', handleGetIsMarketOpen, api);
}

function* handleGetIsMarketOpen(api: AdminGateway) {
    const authToken = store.getState().auth.userDetails.authToken;

    yield put(combinedActions.authGetIsMarketOpenSuccess(false));
}
